import { render, staticRenderFns } from "./ModalInfo.vue?vue&type=template&id=40d5c248&scoped=true&"
import script from "./ModalInfo.vue?vue&type=script&lang=js&"
export * from "./ModalInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfo.vue?vue&type=style&index=0&id=40d5c248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d5c248",
  null
  
)

export default component.exports